export default {
  twoWay: true,
  bind: function (el, bind, vn) {
      const trans = vn.context.trans;

      var val_container = bind.value;

      if (bind.value && bind.value.length > bind.arg) {
          vn.elm.textContent = bind.value.substring(0, bind.arg);
          var read_more = document.createElement("a");
          read_more.href = "#";
          read_more.textContent = trans.read_more;
          read_more.classList.add("btn-link");
    
          var read_less = document.createElement("a");
          read_less.href = "#";
          read_less.textContent = trans.read_less;
          read_less.classList.add("btn-link");
    
          vn.elm.append(" ", "...", " ", read_more);
    
          read_more.addEventListener("click", function() {
            vn.elm.textContent = val_container;
            vn.elm.append(" ", read_less);
          });
    
          read_less.addEventListener("click", function() {
            vn.elm.textContent = bind.value.substring(0, bind.arg);
            vn.elm.append(" ", "...", " ", read_more);
          });
        } else {
          vn.elm.textContent = bind.value;
        }
  }
};
